var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "#8E9499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_201_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.547 18.554H14.78V23H11.626V9.7H16.547C19.34 9.7 21.24 11.5335 21.24 14.127C21.24 16.7205 19.34 18.554 16.547 18.554ZM18.124 14.127C18.124 12.9775 17.4115 12.208 16.205 12.208H14.78V16.046H16.205C17.4115 16.046 18.124 15.2765 18.124 14.127Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_201_114",
    x: 9.62598,
    y: 9.7,
    width: 13.614,
    height: 17.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_114",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.d5f26ea7504137990d718e8fd9e8579c.svg";
export { ForwardRef as ReactComponent };